import React, { useState, useRef, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { MdOutlineCalendarMonth } from "react-icons/md";
import back from "../../Asset/product/back.png";

const PickSchudle = ({
  selectedDate,
  setSelectedDate,
  selectedOption,
  setSelectedOption,
  selectedDays,
  setSelectedDays,
  selectedDatee,
  setSelectedDatee,
}) => {
  const [showPicker, setShowPicker] = useState(false);
  const calendarRef = useRef(null);
  const formatDate = (date) => {
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    });
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (calendarRef.current && !calendarRef.current.contains(event.target)) {
        setShowPicker(false);
      }
    };

    if (showPicker) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showPicker]);
  const [showModal, setShowModal] = useState(false);

  const weekdays = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];

  const toggleDay = (day) => {
    setSelectedDays((prev) =>
      prev.includes(day) ? prev.filter((d) => d !== day) : [...prev, day]
    );
  };

  const toggleDate = (date) => {
    setSelectedDatee((prev) =>
      prev.includes(date) ? prev.filter((d) => d !== date) : [...prev, date]
    );
  };

  const handleDone = () => {
    setShowModal(false);
  };

  const renderModalContent = () => {
    if (selectedOption === "weekly") {
      return (
        <div className="bg-white px-6 py-3 rounded-lg w-full max-w-md"
         data-aos="flip-up"
         style={{
        backgroundImage: `url(${back})`,
        backgroundRepeat: "repeat",
        backgroundSize: "auto",
      }}>
          <h2 className="text-lg  mb-4 text-textColor"
          style={{ fontFamily: "Salsa, sans-serif" }}>
            Tap to select week days
          </h2>
          {weekdays.map((day) => (
            <label key={day} className="block mb-1">
              <input
                type="checkbox"
                className="mr-2 accent-textColor border-2 border-textColor"
                checked={selectedDays.includes(day)}
                onChange={() => toggleDay(day)}
              />
              {day}
            </label>
          ))}
          <div className="mt-2 w-full flex justify-end">
            <button
              className=" bg-textColor text-white px-6 py-2 rounded-2xl "
              onClick={handleDone}
            >
              Close
            </button>
          </div>
        </div>
      );
    }

    if (selectedOption === "monthly") {
      return (
        <div className="bg-white px-6 py-3 rounded-xl w-full max-w-md" 
         data-aos="flip-up"
         style={{
        backgroundImage: `url(${back})`,
        backgroundRepeat: "repeat",
        backgroundSize: "auto",
      }}>
          <h2 className="text-lg  mb-4 text-textColor" style={{ fontFamily: "Salsa, sans-serif" }}>
            Tap to select dates
          </h2>
          <div className="grid grid-cols-5 gap-1.5 max-h-72 overflow-y-auto">
            {Array?.from({ length: 30 }, (_, i) => i + 1)?.map((date) => (
              <button
                key={date}
                className={`${
                  selectedDatee?.includes(date) ? "bg-textColor text-white" : ""
                } h-10 w-10 rounded-full`}
                onClick={() => toggleDate(date)}
              >
                {date}
              </button>
            ))}
          </div>
          <div className="w-full flex justify-end">
            <button
              className="mt-4 bg-textColor text-white px-6 py-2 rounded-2xl"
              onClick={handleDone}
            >
              Close
            </button>
          </div>
        </div>
      );
    }

    return null;
  };

  return (
    <div className="w-full flex flex-col">
      <div className="w-full">
        <span className="text-textColor font-semibold text-base title1">
          Pick Schedule
        </span>
      </div>

      <div className="mt-4 bg-[#F6F7F3] rounded-2xl px-4 py-4 flex flex-col">
        <div className=" flex flex-col md:flex-row gap-1 md:gap-4 justify-between items-center cursor-pointer relative ">
          <MdOutlineCalendarMonth className="text-3xl text-[#5D6D56]" />

          <input
            type="text"
            className="w-full px-2 py-2 bg-[#F6F7F3]"
            placeholder="Subscription Start Date"
            value={selectedDate ? formatDate(selectedDate) : ""}
            readOnly
          />

          {showPicker && (
            <div className="absolute top-full mt-2 z-10" ref={calendarRef}>
              <DatePicker
                selected={selectedDate}
                onChange={(date) => {
                  setSelectedDate(date);
                  setShowPicker(false);
                }}
                inline
                minDate={new Date()}
              />
            </div>
          )}

          <button
            className="bg-textColor text-white px-8 flex items-center justify-center py-3 md:py-1 rounded-xl w-full md:w-20"
            onClick={() => {
              if (selectedDate) {
                setSelectedDate(null);
              } else {
                setShowPicker(true);
              }
            }}
          >
            {selectedDate ? "Remove" : "Select"}
          </button>
        </div>
        <div className="w-full  pt-4 grid grid-cols-3 gap-6 xl:gap-12">
          <button
            className={`${
              selectedOption == "daily" ? "bg-[#DCE5D6]" : "bg-[#EDF6E9]"
            }  py-2 rounded-xl cursor-pointer`}
            onClick={() => {
              setSelectedOption("daily");
              setSelectedDays([]);
              setSelectedDatee([]);
            }}
          >
            Daily
          </button>
          <button
            className={`${
              selectedOption == "weekly" ? "bg-[#DCE5D6]" : "bg-[#EDF6E9]"
            }  py-2 rounded-xl cursor-pointer`}
            onClick={() => {
              setSelectedOption("weekly");
              setSelectedDatee([]);
              setShowModal(true);
            }}
          >
            Weekly
          </button>
          <button
            className={`${
              selectedOption == "monthly" ? "bg-[#DCE5D6]" : "bg-[#EDF6E9]"
            }  py-2 rounded-xl cursor-pointer`}
            onClick={() => {
              setSelectedOption("monthly");
              setSelectedDays([]);
              setShowModal(true);
            }}
          >
            Monthly
          </button>
        </div>
        <div className="w-full py-4">
         <div className="flex flex-wrap gap-2 w-full p-2">
  {selectedOption === "weekly" &&
    selectedDays?.map((day, index) => (
      <button
        key={index}
        className="px-3 py-1 rounded-lg bg-textcolor2 text-white text-sm"
      >
        {day}
      </button>
    ))}

  {selectedOption === "monthly" &&
    selectedDatee
      ?.sort((a, b) => a - b)
      .map((date, index) => (
        <button
          key={index}
          className="h-8 w-8 rounded-full bg-textcolor2 text-white text-sm"
        >
          {date}
        </button>
      ))}
</div>
        </div>

        {/* Modal */}
        {showModal && (
          <div
            className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
            onClick={() => {
              if (selectedDays?.length === 0 && selectedDatee?.length === 0) {
                setSelectedOption("daily");
              }
              setShowModal(false);
            }}
          >
            <div
              className="bg-white px-6 py-3 rounded-xl w-full max-w-md"
              onClick={(e) => e.stopPropagation()}
            >
              {renderModalContent()}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PickSchudle;
